import { Card, Grid, Typography } from '@mui/material'

import { numberFormat } from '../../../../../utils'
import { calcEstimatedProfit, calcSettledProfit } from '../utils'

interface Props {
  successTotal: number // ยอดขายสถานะสำเร็จ (COMPLETED + DELIVERED)
  successCostTotal: number // ต้นทุนสินค้าของออเดอร์สำเร็จ
  feeTotal: number // ค่าธรรมเนียม TikTok (ค่าลบ) — มีเฉพาะออเดอร์ที่โอนเงินแล้ว
  costTotal: number // ค่าใช้จ่ายอื่นที่ร้านบันทึกเอง (เมนูค่าใช้จ่าย)
  netTotal: number // ยอดที่ได้รับจริง (หักค่าธรรมเนียมแล้ว) — เฉพาะออเดอร์ที่โอนแล้ว
}

const FinanceCards = ({
  successTotal,
  successCostTotal,
  feeTotal,
  costTotal,
  netTotal,
}: Props) => {
  const estimatedProfit = calcEstimatedProfit(
    { successTotal, successCostTotal, feeTotal },
    costTotal,
  )
  const settledProfit = calcSettledProfit(
    { netTotal, successCostTotal },
    costTotal,
  )

  const items = [
    {
      label: 'ยอดขายสำเร็จ',
      value: successTotal,
      color: '#52c41a',
      hint: 'สถานะสำเร็จ + จัดส่งสำเร็จ',
    },
    {
      label: 'ต้นทุนสินค้า',
      value: successCostTotal,
      color: '#faad14',
      hint: 'ต้นทุนของออเดอร์สำเร็จ',
    },
    {
      label: 'ค่าธรรมเนียม',
      value: feeTotal,
      color: '#cf1322',
      hint: 'นับเฉพาะออเดอร์ที่ TikTok โอนเงินแล้ว',
    },
    {
      label: 'ค่าใช้จ่ายอื่น',
      value: costTotal,
      color: '#fa541c',
      hint: 'ค่าใช้จ่าย TikTok ที่บันทึกในช่วงนี้',
    },
    {
      label: 'กำไรประมาณการ',
      value: estimatedProfit,
      color: estimatedProfit >= 0 ? '#1677ff' : '#cf1322',
      hint: 'ยอดขายสำเร็จ − ต้นทุนสินค้า − ค่าธรรมเนียม − ค่าใช้จ่ายอื่น',
    },
    {
      label: 'กำไรสุทธิจริง',
      value: settledProfit,
      color: settledProfit >= 0 ? '#1677ff' : '#cf1322',
      hint: `ได้รับจริง ฿${numberFormat(
        netTotal,
        2,
      )} − ต้นทุนสินค้า − ค่าใช้จ่ายอื่น`,
    },
  ]

  return (
    <Grid container spacing={2} mb={2} columns={{ xs: 1, sm: 2, lg: 6 }}>
      {items.map((item) => (
        <Grid item xs={1} key={item.label}>
          <Card
            variant="outlined"
            sx={{ p: 2, height: '100%', borderLeft: `4px solid ${item.color}` }}
          >
            <Typography variant="body2" color="text.secondary">
              {item.label}
            </Typography>
            <Typography
              variant="h5"
              sx={{ mt: 1, fontWeight: 600, color: item.color }}
            >
              ฿{numberFormat(item.value, 2)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {item.hint}
            </Typography>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}

export default FinanceCards
